import { Link } from 'react-router-dom';

import CtaLink from '@/components/CtaLink';
import { contactSales } from '@/lib/salesContact';
import { withCta } from '@/lib/ctaTracking';

/**
 * CtaFinalOscuro — el bloque negro con el que cierran las once páginas del V3.
 *
 * Es el mismo en todas salvo el titular, así que va como componente y no
 * copiado once veces. Los dos CTAs que lleva (empezar la prueba y hablar con
 * ventas) sí cambian de id según la página: quién cierra la venta es
 * exactamente lo que se quiere poder comparar entre la home y, por ejemplo,
 * Restauración. Por eso `ctaTrial` y `ctaVentas` son props y no literales — el
 * mismo criterio que `UpgradeCard` con su `ctaId`.
 */
export default function CtaFinalOscuro({
  tituloA,
  acento,
  subtitulo,
  cta,
  microcopy,
  enterpriseA,
  enterpriseCta,
  ctaTrial,
  ctaVentas,
}) {
  return (
    <section className="px-6 pb-20">
      <div className="max-w-[1180px] mx-auto bg-v3-ink rounded-3xl px-6 py-14 md:px-12 md:py-[62px] text-center">
        <h2 className="text-[30px] md:text-[42px] leading-[1.08] tracking-[-.03em] font-bold text-white mx-auto max-w-[18ch]">
          {tituloA}
          <span className="text-v3-gold">{acento}</span>
        </h2>

        {subtitulo ? (
          <p className="text-[16.5px] leading-[1.6] text-v3-faint mt-4 mx-auto max-w-[60ch]">
            {subtitulo}
          </p>
        ) : null}

        <div className="mt-7">
          <CtaLink
            as={Link}
            cta={ctaTrial}
            to={withCta('/register', ctaTrial)}
            className="inline-block bg-v3-gold hover:bg-v3-golddeep text-v3-ink text-[17px] md:text-[18px] font-bold rounded-full px-8 py-4 md:px-[42px] md:py-[19px] shadow-[0_10px_30px_rgba(254,174,44,.3)] transition-colors"
          >
            {cta}
          </CtaLink>
        </div>

        <div className="text-[13.5px] text-v3-faint mt-[18px]">{microcopy}</div>

        <div className="h-px bg-white/[.12] mx-auto mt-[30px] max-w-[420px]" aria-hidden="true" />

        <div className="text-[13.5px] text-v3-faint mt-[18px]">
          {enterpriseA}
          <CtaLink
            as="button"
            cta={ctaVentas}
            onClick={contactSales}
            className="text-white font-semibold border-b border-white/40 hover:border-white transition-colors"
          >
            {enterpriseCta}
          </CtaLink>
        </div>
      </div>
    </section>
  );
}
